module.exports = require("./chr.js");